import React, { useCallback, useState } from 'react';

import Button, { LoadingButton } from '@atlaskit/button';
import TextArea from '@atlaskit/textarea';

import { trackEvent } from 'src/lib/analytics';
import jira from 'src/lib/api/jira';
import pagerduty from 'src/lib/api/pagerduty';
import { getQueryParams } from 'src/lib/history';

import ErrorMessage from 'src/views/components/ErrorMessage';
import Field from 'src/views/components/Form/Field';
import ModalButtons from 'src/views/components/ModalButtons';
import ModalContainer from 'src/views/components/ModalContainer';
import { PdEscalationPolicySelect, PdUsersSelect } from 'src/views/components/select';

const analyticsEventName = 'sidebar_incidentresponse_add_responders';
const ModalAddResponders = () => {
  const { incidentId, incidentTitle } = getQueryParams();

  const [{ submitting, error }, setState] = useState({});
  const [values, setValues] = useState({ users: [], escalationPolicies: [], message: `Please help with "${incidentTitle}"` });

  const closeModal = () => {
    trackEvent(analyticsEventName, { label: 'cancel' });
    jira.closeCurrentModal();
  };

  const addResponders = useCallback((e) => {
    setState({ submitting: true });
    trackEvent(analyticsEventName, { label: 'add_responders' });
    pagerduty
      .getMe()
      .then(({ id: requesterId }) => pagerduty.addResponders(requesterId, incidentId, values.message, values.users, values.escalationPolicies))
      .then(() => jira.closeCurrentModal())
      .catch(error => setState({ error }));
  }, [incidentId, values]);

  const onChange = useCallback(({ target: { value, name } }) => {
    setValues(v => ({ ...v, [name]: value }));
  }, []);

  const canSubmit = (values.users && values.users.length)
    || (values.escalationPolicies && values.escalationPolicies.length);

  return (
    <ModalContainer title="Add Responders">
      <Field label="Users">
        <PdUsersSelect
          isClearable
          placeholder="Select Users..."
          value={values.users}
          name="users"
          isMulti
          onChange={onChange}
          className="users-select"
        />
      </Field>

      <Field label="Escalation policies">
        <PdEscalationPolicySelect
          isClearable
          placeholder="Select Escalation policies..."
          value={values.escalationPolicies}
          name="escalationPolicies"
          isMulti
          onChange={onChange}
          className="escalation-policies-select"
        />
      </Field>

      <Field label="You may include a brief message for your responder">
        <TextArea
          minimumRows={5}
          placeholder="Please add your message here"
          value={values.message}
          name="message"
          onChange={onChange}
          className="message"
        />
      </Field>

      {error && <ErrorMessage error={['Failed to add responders', error]}/>}

      <ModalButtons>
        <Button onClick={closeModal}>Cancel</Button>
        <LoadingButton appearance="primary" isLoading={submitting} onClick={addResponders} isDisabled={!canSubmit}>Add Responders</LoadingButton>
      </ModalButtons>
    </ModalContainer>
  );
};

export default ModalAddResponders;
